import React from "react"

const _MouthPeace = ({ isEditor }: { isEditor: boolean }) => {
  return (
    <svg
      style={{
        width: !isEditor ? "50%" : "80%",
        height: !isEditor ? "19%" : "80%",
        position: "absolute",
        top: !isEditor ? "23%" : "42%",
        right: !isEditor ? "23%" : "6%"
      }}
      width="67"
      height="64"
      viewBox="0 0 67 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 17.5C5 34.5 33.5 42.5 59.5 23"
        stroke="black"
        strokeWidth="4"
      />
    </svg>
  )
}

export const MouthPeace = React.memo(_MouthPeace)
